import { createRequest } from "@/api/UpgradePlanAPI";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const createplanReq = createAsyncThunk("upgradePlan/createRequest", async (reqData) => {
    return await createRequest(reqData);
});

const UpgradePlanReqSlice = createSlice({
    name: "upgradePlan",
    initialState: {
        data: null,
        loading: false,
        error: null,
        filtered: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createplanReq.pending, (state) => { state.loading = true })
            .addCase(createplanReq.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload
            })
            .addCase(createplanReq.rejected, (state) => {
                state.loading = false;
                state.data = null;
                state.error = "Something Went Wrong!";
            });
    }
});

export default UpgradePlanReqSlice.reducer;